import React, { useState, useRef } from "react";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";

const OptionInput = (props) => {
  const { placeholder, data, filter, setFilter } = props;
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);

  const inputRef = useRef();
  const menuRef = useRef();

  window.addEventListener("click", (e) => {
    if (e.target !== menuRef.current && e.target !== inputRef.current) {
      setOpen(false);
    }
  });


  const handleDeleteFilter = () =>{
    setSelected("");
    // setOpen(false);

    if (
      placeholder === "Job Type"
    ) {
       
      delete filter.job_type
      setFilter({
        ...filter
      });
    } else if (
      placeholder === "Assign By" 
    ) {
      delete filter.assign_by
      setFilter({
        ...filter
      });
    } else if (
      placeholder === "Stages" 
      
    ) {
      delete filter.stages
      setFilter({
        ...filter
      });
    }
  }



  return (
    <div className="w-full border h-[40px]  border-[#CBD5E1]  rounded-lg font-medium ">
      <div
        ref={inputRef}
        onClick={() => setOpen(!open)}
        className={` w-full h-[40px] p-2  relative flex text-sm text-[#6C757D] items-center justify-between rounded-lg  cursor-pointer ${
          !selected && "text-[#6C757D]"
        }`}
      >
        {selected
          ? selected?.length > 25
            ? selected?.substring(0, 25) + "..."
            : selected
          : placeholder}
        {selected.length > 0 && (
          <XMarkIcon
            onClick={handleDeleteFilter}
            className={` h-4 cursor-pointer absolute z-10 right-7 `}
          />
        )}
        <ChevronDownIcon
          className={` h-4 cursor-pointer -z-10  ${open && "rotate-180  h-4 "}`}
        />
      </div>
      <ul
        ref={menuRef}
        style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
        className={` relative bg-white mt-2 overflow-y-auto z-40  rounded-lg ${
          open ? "max-h-60" : "max-h-0"
        } `}
      >
        {data?.length>0 && data?.map((item) => {
          return (
            <li
              key={
                placeholder === "Job Type"
                  ? item?.id
                  : placeholder === "Stages"
                  ? item?.param
                  : item?.assigned_by_name
              }
              className={`p-2 text-sm cursor-pointer  hover:bg-[#2563EB] hover:text-white
           `}
              onClick={() => {
                if (
                  placeholder === "Job Type" &&
                  item?.job_type?.toLowerCase() !== selected?.toLowerCase()
                ) {
                  setSelected(item?.job_type);
                  setOpen(false);
                  setFilter({
                    ...filter,
                    job_type: { id: item?.id, job_type: item?.job_type },
                  });
                } else if (
                  placeholder === "Assign By" &&
                  item?.assigned_by_name?.toLowerCase() !==
                    selected?.toLowerCase()
                ) {
                  setSelected(item?.assigned_by_name);
                  setOpen(false);
                  setFilter({ ...filter, assign_by: { ...item } });
                } else if (
                  placeholder === "Stages" &&
                  item?.job_stage?.toLowerCase() !== selected?.toLowerCase()
                ) {
                  setSelected(item?.job_stage);
                  setOpen(false);
                  setFilter({ ...filter, stages: { ...item } });
                }
              }}
            >
              {placeholder === "Job Type"
                ? item?.job_type
                : placeholder === "Stages"
                ? item?.job_stage
                : item?.assigned_by_name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default OptionInput;
